<div class="flex flex-col h-full min-h-0">
  <!-- Header -->
  <div class="border-b border-gray-200 px-4 py-2 shrink-0 h-[55px] flex items-center">
    <span class="text-base font-semibold text-gray-900">{{ sectionTitle }}</span>
  </div>

  <div class="flex-1 min-h-0 overflow-y-auto pt-2">
    @if (regularModules.length === 0 && sharedModules.length === 0) {
      <div class="flex flex-col items-center justify-center py-12 text-center">
        <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2"/>
          </svg>
        </div>
        <span class="text-sm text-gray-500">Keine Module gefunden</span>
      </div>
    } @else {
      <div class="flex flex-col gap-2">
        @for (mod of regularModules; track mod.moduleId) {
          <div
            (dragstart)="onDragStart($event, mod)"
            class="flex items-center gap-4 w-full px-4 py-2 hover:bg-gray-50 text-left transition-colors cursor-grab active:cursor-grabbing"
            draggable="true">
            <div class="flex items-center justify-center size-4 shrink-0">
              @if (getModuleIcon(mod)) {
                <fa-icon [icon]="getModuleIcon(mod)!" class="text-gray-500 text-sm"></fa-icon>
              } @else {
                <span class="text-[10px] font-bold text-gray-500">{{ getCategoryInfo(mod)?.abbrev || '?' }}</span>
              }
            </div>
            <div class="flex flex-col min-w-0 flex-1">
              <span class="text-sm font-medium text-gray-900 leading-5 truncate">{{ mod.name }}</span>
              <span class="text-xs text-gray-500 leading-[18px] truncate">{{ mod.description }}</span>
            </div>
          </div>
        }

        @if (sharedModules.length > 0) {
          <div class="h-[55px] border-y border-gray-200 flex items-center px-4 py-2 mt-1">
            <span class="text-base font-medium text-gray-900">Geteilte Module</span>
          </div>
          @for (mod of sharedModules; track mod.moduleId) {
            <div
              (dragstart)="onDragStart($event, mod)"
              class="flex items-center gap-4 w-full px-4 py-2 hover:bg-gray-50 text-left transition-colors cursor-grab active:cursor-grabbing"
              draggable="true">
              <div class="flex items-center justify-center size-4 shrink-0">
                @if (getCategoryInfo(mod)?.icon) {
                  <fa-icon [icon]="getCategoryInfo(mod)!.icon!" class="text-gray-500 text-sm"></fa-icon>
                } @else {
                  <span class="text-[10px] font-bold text-gray-500">{{ getCategoryInfo(mod)?.abbrev || '?' }}</span>
                }
              </div>
              <div class="flex flex-col min-w-0 flex-1">
                <span class="text-sm font-medium text-gray-900 leading-5 truncate">{{ mod.name }}</span>
                <span class="text-xs text-gray-500 leading-[18px] truncate">{{ mod.description }}</span>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>

  <!-- Suche im Footer (Figma) -->
  <div class="shrink-0 p-6">
    <bic-input (valueChange)="searchQueryChange.emit($event)"
               [iconStart]="faMagnifyingGlass"
               [placeholder]="'Module suchen...'"
               [showX]="true"
               [value]="searchQuery">
    </bic-input>
  </div>
</div>
